import React, { useRef } from 'react'
import { DialogOverlay, DialogOverlayContent, useOverlay } from '@fs/zion-ui'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { func } from 'prop-types'
import StationSignOutBox from './StationSignOutBox'
import HambugerIcon from './images/hamburger.png'
import { useTakeAwaysData } from './hooks'

const downloadHeaderCSS = css`
  height: 50px;
  background-color: #8dbd4a;
  display: flex;
  align-items: center;
`

const downloadHeaderLabelCSS = css`
  display: inline-block;
  font-family: Verdana, sans-serif;
  font-size: 20px;
  padding: 15px;
`
const takeAwayItemCSS = css`
  width: 160px;
  height: 160px;
  margin: 20px;
`

const takeAwayListContainerCSS = css`
  margin: 20px;
`

const TakeAwaysList = ({ toggleDrawer, dialogOpener, setSelectedImageSrc }) => {
  const azUserSessionId = sessionStorage.getItem('userSessionId')
  const takeAwayListData = useTakeAwaysData(azUserSessionId)

  const viewTakeAway = (url) => {
    toggleDrawer()
    setSelectedImageSrc(url)
    dialogOpener.open()
  }

  return (
    <>
      <div css={takeAwayListContainerCSS}>
        {takeAwayListData.map((takeAway) => (
          <div key={takeAway.cloudUrl}>
            <div
              onKeyPress={() => {
                viewTakeAway(takeAway.cloudUrl)
              }}
              role="button"
              onClick={() => {
                viewTakeAway(takeAway.cloudUrl)
              }}
              css={takeAwayItemCSS}
              key={takeAway.imageHash}
              tabIndex={0}
            >
              <img src={takeAway.cloudThumbUrl} alt="" css={{ width: '100%' }} />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default function StationDrawer({ logoutCallback }) {
  const [t] = useTranslation()
  const dialogOpener = useOverlay()
  const [selectedImageSrc, setSelectedImageSrc] = React.useState()
  const [drawerState, setDrawerState] = React.useState({
    bottom: false,
    right: false,
    top: false,
    left: false,
  })

  const toggleFunc = useRef((side, open) => () => {
    setDrawerState({ ...drawerState, [side]: open })
  })

  const drawerContentsCSS = css`
    background-color: #999999;
    height: 100vh;
    width: 450px;
  `

  const hamburgerCSS = css`
    align-items: center;
    margin-top: 20px;
    margin-right: 20px;
  `

  return (
    <>
      <div
        tabIndex={0}
        onKeyPress={() => toggleFunc.current('right', true)}
        onClick={toggleFunc.current('right', true)}
        role="button"
        css={hamburgerCSS}
      >
        <img src={HambugerIcon} alt="Hamburger" />
      </div>
      <SwipeableDrawer
        open={drawerState.right}
        onClose={toggleFunc.current('right', false)}
        onOpen={toggleFunc.current('right', true)}
        anchor="right"
        disableSwipeToOpen
      >
        <div css={drawerContentsCSS}>
          <StationSignOutBox logoutCallback={logoutCallback} toggleDrawer={toggleFunc.current} />
          <div css={downloadHeaderCSS}>
            <span css={downloadHeaderLabelCSS}>{t('station.downloads', 'Downloads')} </span>
          </div>
          <TakeAwaysList
            opened={drawerState.right}
            dialogOpener={dialogOpener}
            toggleDrawer={toggleFunc.current('right', false)}
            setSelectedImageSrc={setSelectedImageSrc}
          />
        </div>
      </SwipeableDrawer>
      <DialogOverlay headingText="" {...dialogOpener} autoWidth>
        <DialogOverlayContent>
          <img src={selectedImageSrc} alt="" css={{ width: '800px' }} />
        </DialogOverlayContent>
      </DialogOverlay>
    </>
  )
}

StationDrawer.propTypes = {
  logoutCallback: func,
}
